import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import DashboardLayout from "../../../shared/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../shared/Navbars/DashboardNavbar";
import Footer from "../../../shared/Footer";
import DataTable from "../../../shared/Tables/DataTable";
import authorService from "../../../services/authorService";
import ActionCell from "./components/ActionCell";
import MDBadge from "../../../components/MDBadge";

function AuthorList() {
  const [authors, setAuthors] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchAuthors(page, limit, search);
  }, [page, limit, search]);

  const fetchAuthors = async (currentPage, currentLimit, currentSearch) => {
    setLoading(true);
    try {
      const response = await authorService.getAll({
        page: currentPage + 1,
        limit: currentLimit,
        q: currentSearch,
        searchFields: "name,last_name,email",
        select: "name,last_name,email,user"
      });
      setAuthors(response.data || []);
      setTotalCount(response.total || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching authors:", error);
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    return status === "activo" ? "success" : "secondary";
  };

  const columns = [
    { Header: "Nombre", accessor: "name", align: "left" },
    { Header: "Apellidos", accessor: "last_name", align: "left" },
    { Header: "Email", accessor: "email", align: "left" },
    { Header: "Estado", accessor: "status", align: "left" },
    { Header: "Acciones", accessor: "actions", align: "center" },
  ];

  const rows = authors.map((author) => ({
    name: <MDTypography variant="button" fontWeight="medium">{author.name}</MDTypography>,
    last_name: <MDTypography variant="caption">{author.last_name}</MDTypography>,
    email: <MDTypography variant="caption">{author.email}</MDTypography>,
    status: <MDBadge badgeContent={author.user.status} color={getStatusColor(author.user.status)} variant="gradient" size="sm" />,
    actions: (
      <MDBox display="flex" alignItems="center">
        <ActionCell id={author._id} action="details" icon="visibility" color="info" />
        <ActionCell id={author._id} action="edit" icon="edit" color="info" />
        <ActionCell id={author._id} action="delete" icon="delete" color="primary" onDelete={fetchAuthors} />
      </MDBox>
    ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={2}
      >
        <MDButton
          component={Link}
          to="/authors/new"
          variant="gradient"
          color="info"
        >
          Nuevo
        </MDButton>
      </MDBox>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">Autores</MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={{ defaultValue: limit, entries: [5, 10, 15, 20, 25] }}
                  showTotalEntries={true}
                  noEndBorder
                  canSearch={true}
                  isManualPagination={true}
                  pageCount={Math.ceil(totalCount / limit)}
                  onPageChange={(newPage) => setPage(newPage)}
                  onPageSizeChange={(newLimit) => setLimit(newLimit)}
                  onSearchChange={(newSearch) => {
                    setSearch(newSearch);
                    setPage(0);
                  }}
                  totalEntries={totalCount}
                  loading={loading}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default AuthorList;